module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"rowNumber":"The number of rows to be displayed"},"ja":{"rowNumber":"表示する行数"},"zh-hant":{"rowNumber":"要顯示的條數"},"zh-hans":{"rowNumber":"要显示的条数"}}')
  delete Component.options._Ctor
}
